import { Validator } from '@vista-digital/validator';
/**
 * Default assets for the Composite Film Filter component.
 */
export const defaultCompositeFilterAssets = {
    filterModalButtonIconName: 'filter'
};
export const compositeFilterAssetsValidator = Validator.object({
    filterModalButtonIconName: Validator.nonEmptyString
});
//# sourceMappingURL=assets.js.map